import React from 'react';
import styles from './styles';
import Tag from '../Tag';

const TagsList = ({ post }) => {
  // Ensure post and post.data are defined before destructuring
  const { time, complexity, tools_needed, video } = post?.data || {};

  const prepareComplexityColors = (tag) => {
    switch (tag) {
      case 'Easy':
        return '#9CF963';
      case 'Intermediate':
        return '#FFA723';
      default:
        return '#9B4DFF';
    }
  };

  return (
    <>
      <div className="tags-wrapper">
        {time && <Tag id="time" title="Mins" data={time} color="#6CADF9" />}
        {complexity && (
          <Tag
            id={complexity}
            title={complexity}
            color={prepareComplexityColors(complexity)}
          />
        )}
        {tools_needed?.length > 0 && (
          <Tag id="tools_needed" title="Tools Needed" color="#E1FF28" />
        )}
        {video?.link_type !== 'Any' && (
          <Tag id="video" title="Video" color="#FA6C6C" />
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default TagsList;
